import { Component, Input, OnInit, output } from '@angular/core';
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { NgxMaskDirective } from "ngx-mask";
import {
  ValidationErrorsComponent
} from "../../../../../../../../common/validation-errors/validation-errors.component";
import { TrunkCircumference130Form } from "../../forms/trunkCircumference130.form";

@Component({
  selector: 'app-trunk-circumference-crud',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    NgxMaskDirective,
    ValidationErrorsComponent
  ],
  templateUrl: './trunk-circumference-crud.component.html'
})
export class TrunkCircumferenceCrudComponent implements OnInit {

  @Input()
  public form: TrunkCircumference130Form | null = null;

  public itemChange = output();

  public ngOnInit(): void {
  }
}
